<template>
    <div>
        <div class="row">
            <div class="col-sm-12">
                <div>
                    <div class="content center-block">
                        <div class="row">
                            <div v-for="product in products" class="center-block well mb-20 action-image-container text-center">
                                <h1>AANBIEDING</h1>
                                <h4 class="text-center panel-heading">{{product.dutchTitle}}</h4>
                                <div class="row">
                                    <div class="col-sm-12 text-center">
                                        <div v-if="product.imageLocation" class="col-sm-12">
                                            <img :src="BACKEND_BASE_URL + '/images/' + product.imageLocation" width="150">
                                        </div>
                                        <div v-if="!product.imageLocation" class="col-sm-12">
                                            <span><i>{{$t("no_picture_available")}}</i></span>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-sm-12" style="margin-top: 20px">
                                        <div :class="loggedInCustomer.showPrices ? 'col-sm-offset-7 col-sm-1' : 'col-sm-offset-6 col-sm-1'">
                                            <label>{{$t("discount")}}</label>
                                        </div>
                                    </div>
                                    <div class="col-sm-12">
                                        <div>
                                            <div class="col-sm-6" style="margin-top:7px; margin-bottom:15px;">
                                                <strong>{{ getLocale() == 'nl' ? product.dutchTitle : product.frenchTitle}} ({{product.articleNumber}})</strong>
                                            </div>
                                            <div class="col-sm-1" style="margin-top: 7px;" v-if="loggedInCustomer.showPrices">
                                                €{{parseFloat(product.price).toFixed(2)}}
                                            </div>
                                            <div class="col-sm-1" style="margin-top: 7px;">
                                                {{product.discount || 0}}%
                                            </div>
                                            <div class="col-sm-2">
                                                <input title="amount" type="number" min="1" step="1" class="form-control" v-model="product.amount">
                                            </div>
                                            <div class="col-sm-2">
                                                <button class="btn btn-info" @click="orderProduct(product)">{{$t("order")}}</button>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-sm-12">
                                        <p>{{ getLocale() == 'nl' ? product.dutchDescription : product.frenchDescription}}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <bt-footer />
    </div>
</template>

<script>
    import BtFooter from './BTFooter.vue'
    import { mapGetters } from 'vuex'
    import * as types from '../store/mutation-types'

    export default {
        name: 'Actions',
        data() {
            return {
                BACKEND_BASE_URL: process.env.VUE_APP_BACKEND_BASE_URL,
            }
        },
        created() {
            document.title = 'Brabant-Tools | Aanbiedingen'
            this.$store.dispatch('getOfferProducts').then(() => {
                if (this.products && this.loggedInCustomer.id) {
                    this.$store.dispatch('getDiscounts').then(() => {
                        this.$store.commit(types.ADD_DISCOUNTS_TO_PRODUCTS, this.discounts)
                        this.$store.dispatch('getPricesForCustomerOnAuth').then(() => {
                            this.$store.commit(types.ADD_CUSTOMER_SPECIFIC_PRICES_TO_PRODUCTS, this.customerSpecificPrices)
                        })
                    })
                }
            })
        },
        methods: {
            getLocale() {
                return this.$i18n.locale
            },
            orderProduct(product) {
                if (isNaN(product.amount)) {
                    product.amount = 1
                }
                this.$store.commit(types.ADD_PRODUCT_TO_SHOPPING_CART, product)
                this.$store.dispatch('saveShoppingCart', this.loggedInCustomer.id)
                if (this.getLocale() === 'nl') {
                    this.$notify({ group: 'success', type: 'success', title: 'Succes', text: 'Product is toegevoegd aan je winkelwagen!' })
                } else {
                    this.$notify({ group: 'success', type: 'success', title: 'Succès', text: 'Le produit a été ajouté à votre panier!' })
                }
            }
        },
        computed: {
            ...mapGetters({
                products: 'products',
                discounts: 'discounts',
                customerSpecificPrices: 'customerSpecificPrices',
                loggedInCustomer: 'loggedInCustomer'
            })
        },
        components: {
            BtFooter
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .glyphicon {
        cursor: pointer;
    }

    .action-image-container {
        width: 800px;
        box-shadow: 5px 5px 5px grey;
    }

        .action-image-container h1 {
            color: #0086be;
            font-weight: bold;
        }

        .action-image-container .glyphicon {
            display: none;
        }

        .action-image-container:hover .glyphicon {
            display: block;
        }
</style>
